<template>
    <div class="user-premission">
        <div class="card">
            <div :class="['card-body', loading ? 'user-loading' : '']">
                <div class="inner-client">
                    <div class="header-list-client">
                        <div class="header-item">User</div>
                        <div class="header-item">Role</div>
                        <div class="header-item">
                            Permissions
                            <div class="show-disabled">
                                <c-switch v-model="showDisabled" @change.native="getUsers()" class="mx-1" color="success" variant="pill" label dataOn="✓" dataOff="✕"/>
                                <span class="show-disabled-label">Show disabled users</span>
                            </div>
                            <button class="btn btn-primary" @click="newUserModalShow()">Create new user</button>
                        </div>
                    </div>
                    <div v-if="!noUsers" class="list-client">
                        <div :class="['item', user.disabled ? 'user-disabled' : '']" v-for="user in usersList" v-bind:key="user.userId">
                            <div class="user">
                                <div class="img-wrap">
                                    <img src="../../assets/img/user-thumbnail.png" alt="" class="light-mode-img">
                                    <img src="../../assets/img/user-thumbnail-dark.png" alt="" class="dark-mode-img">
                                </div>
                                <div class="data-wrap">
                                    <strong>{{user.firstName}} {{user.lastName}}</strong>
                                    <span>{{user.email}}</span>
                                </div>
                            </div>

                            <div class="role">
                                <span :class="[user.role.roleName]">{{user.role.roleName}}</span>
                            </div>

                            <div class="actions">
                                <div class="permissions-list">
                                    <span v-for="perm of user.parsedPermissions" class="permission-item">{{perm}}</span>
                                </div>
                                <button v-if="user.role.roleName != 'Owner'" @click="editUser(user)" class="edit-user">
                                    <i class="fa fa-pencil"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="not-users" v-else>
                        This company don't have any users
                    </div>
                </div>
                <div class="loader-users-list" v-if="loading && !noUsers">
                    <div class="loading-sims-inner">
                        <div class="sk-wave">
                            <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                        </div>

                        <div class="text">
                            Users are being loaded.
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <b-modal ref="editUserModal" v-model="showAdminModal" size="lg" id="admin-edit-user" centered hide-footer>
            <div class="content-box">
                <div class="sidebar">
                    <h3 class="header-modal-text">New User</h3>
                    <h4 class="header-section">Role</h4>
                    <ul class="sidebar-roles">
                        <li>
                            <input type="radio" :disabled="true" id="role1" name="role" value="4" v-model="editUserData.role.roleId">
                            <label for="role1">
                                <strong>Owner</strong>
                                <em>The Owner has access to: Client list, fulfilment, user & permissions, support</em>
                            </label>
                        </li>
                        <li>
                            <input type="radio" :disabled="loggedUser.email == editUserData.email || blockEdition" id="role2" name="role" value="5" v-model="editUserData.role.roleId">
                            <label for="role2">
                                <strong>Super Admin</strong>
                                <em>The Super Admin has access to: Client list, fulfilment, support</em>
                            </label>
                        </li>
                        <li>
                            <input type="radio" :disabled="loggedUser.email == editUserData.email || blockEdition" id="role3" name="role" value="6" v-model="editUserData.role.roleId">
                            <label for="role3">
                                <strong>Fulfilment</strong>
                                <em>The Fullfillment has access to: Fullfillment</em>
                            </label>
                        </li>
                        <li>
                            <input type="radio" :disabled="loggedUser.email == editUserData.email || blockEdition" id="role4" name="role" value="8" v-model="editUserData.role.roleId">
                            <label for="role4">
                                <strong>Support</strong>
                                <em>The Support has access to: support</em>
                            </label>
                        </li>
                    </ul>

                    <h4 class="header-section">Recieve the Following Emails</h4>

                    <ul class="sidebar-email">
                        <li>
                            <FTScheckbox :disable="blockEdition" v-model="editUserData.mailingLists.invoice" :label="'Invoices & Statements'"></FTScheckbox>
                        </li>
                        <li>
                            <FTScheckbox :disable="blockEdition" v-model="editUserData.mailingLists.maintenance" :label="'Maintenance Notifications'"></FTScheckbox>
                        </li>
                        <li>
                            <FTScheckbox :disable="blockEdition" v-model="editUserData.mailingLists.news" :label="'News'"></FTScheckbox>
                        </li>
                    </ul>
                </div>
                <div :class="['content-modal', blockEdition ? 'fields-blocked' : '']">
                    <h3 class="header-modal-text">User Information</h3>

                    <fieldset>
                        <label for="admin-fname">First Name</label>
                        <input :disabled="blockEdition" v-model="editUserData.firstName" type="text" class="form-control" id="admin-fname" placeholder="Enter first name" v-validate="'required|alpha'" data-vv-as="admin-fname" name="admin-fname">
                        <span v-show="errors && errors.has('admin-fname')" class="validate-warning">{{ errors.first('admin-fname') }}</span>
                    </fieldset>

                    <fieldset>
                        <label for="admin-lname">Last Name</label>
                        <input :disabled="blockEdition" v-model="editUserData.lastName" type="text" class="form-control" id="admin-lname" placeholder="Enter last name" v-validate="'required|alpha'" data-vv-as="admin-lname" name="admin-lname">
                        <span v-show="errors && errors.has('admin-lname')" class="validate-warning">{{ errors.first('admin-lname') }}</span>
                    </fieldset>

                    <fieldset>
                        <label for="admin-email">Email</label>
                        <input :disabled="blockEdition || blockEmailEdition" v-model="editUserData.email" type="text" class="form-control" id="admin-email" placeholder="Enter e-mail" v-validate="'required|email'" data-vv-as="admin-email" name="admin-email">
                        <span v-show="errors && errors.has('admin-email')" class="validate-warning">{{ errors.first('admin-email') }}</span>
                    </fieldset>

                    <h3 class="header-modal-text">Password</h3>

                    <fieldset>
                        <label for="admin-npswd">New Password</label>
                        <input :disabled="blockEdition" type="password" v-model="newPassword" class="form-control" id="password" ref="password" placeholder="Enter new password" data-vv-as="password" name="password">
                        <span v-show="errors && errors.has('password')" class="validate-warning">{{ errors.first('password') }}</span>
                    </fieldset>

                    <fieldset>
                        <label for="admin-rnpswd">Repeat New Password</label>
                        <input :disabled="blockEdition" type="password" class="form-control" id="confirm-password" placeholder="Repeat new password" v-validate="'confirmed:password'" data-vv-as="confirm-password" name="confirm-password">
                        <span v-show="errors && errors.has('confirm-password')" class="validate-warning">{{ errors.first('confirm-password') }}</span>
                    </fieldset>
                </div>
            </div>
            <div class="control-bar">
                <a v-if="initialUserData.disabled" @click="reactiveUser()" :class="['disable-user', (blockEdition || blockEmailEdition) ? 'block-disable' : '']">REACTIVATE USER</a>
                <a v-else @click="showDisableUserModal()" :class="['disable-user', (blockEdition || blockEmailEdition) ? 'block-disable' : '']">DISABLE USER</a>
                <div class="cancel-save-btns">
                    <button @click="rejectChanges" class="btn btn-light">Cancel</button>
                    <button @click="saveChanges" class="btn btn-success">Save</button>
                </div>
            </div>
        </b-modal>


        <b-modal ref="unsaved" id="unsaved" :class="['unsaved-edit-user']" centered hide-footer>
            <img  src="../../assets/img/unsaved-data.png" alt />

            <h3>Unsaved Data</h3>
            <h4>User edition will not be saved, do you wan to continue?</h4>
            <div class="button-wrapper">
                <b-button variant="danger" @click="$refs['unsaved'].hide()">Cancel</b-button>
                <b-button variant="success" @click="cancelChanges">Continue</b-button>
            </div>
        </b-modal>


        <b-modal ref="disableUserModal" id="disableUserModal" centered :class="['delete-user-modal']" hide-footer>
            <img  src="../../assets/img/unsaved-data.png" alt />

            <h3>Disable user</h3>
            <h4>Are you sure you want to disable this user?<br/>
                Ability to login will be blocked.</h4>
            <div class="button-wrapper">
                <b-button variant="light" @click="$refs['disableUserModal'].hide()">Cancel</b-button>
                <b-button variant="success" @click="disableUser()">Yes, disable user</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import Axios from 'axios'
    import globalStore from "../../variables";
    import VeeValidate from "vee-validate";
    import Vue from "vue";
    import FTScheckbox from "../../ftsComponents/FTScheckbox";
    import globalStorage from '../../variables'
    import VueCookies from "vue-cookies";
    import FTSdropdown from "../../ftsComponents/FTSdropdown";
    import { Switch as cSwitch } from "@coreui/vue";

    const veeValidateConfig = {};

    Vue.use(VeeValidate, veeValidateConfig);
    Vue.use(VueCookies);
    Vue.$cookies.config('7d','','',true)

    export default {
        name: 'UserPermissions',
        components: {
            FTSdropdown,
            FTScheckbox,
            cSwitch
        },
        data() {
            return {
                showAdminModal: false,
                editUserData: {
                    userId: 0,
                    firstName: '',
                    lastName: '',
                    email: '',
                    role: {
                        roleId: 0,
                        roleName: ''
                    },
                    mailingLists: {
                        news: false,
                        invoice: false,
                        maintenance: false
                    }
                },
                usersList: [],
                permissionsList: [],
                noUsers: false,
                loading: false,
                emails1: false,
                emails2: false,
                emails3: false,
                initialUserData: {},
                newPassword: '',
                rejectChangesPopup: false,
                loggedUser: {
                    email: null,
                    accessLevel: null
                },
                blockEdition: false,
                blockEmailEdition: false,
                showDisabled: null
            }
        },
        methods: {
            getUsers(){
                this.loading = true;
                Axios.get(globalStore.data.restApiUrl + '/admin/users?showDisabled=' + this.showDisabled)
                    .then(response => {
                        let usersList = response.data.response
                        Axios.get(globalStore.data.restApiUrl + '/admin/super-admin-permissions')
                            .then(response => {
                                this.permissionsList = []
                                for (let item of response.data) {
                                    for (let permission of item.typePermissions) {
                                        this.permissionsList.push(permission)
                                    }
                                }
                                this.usersList = usersList;
                                for (let user of this.usersList) {
                                    user.parsedPermissions = []
                                    for (let perm of this.permissionsList) {
                                        if (user.userPermissions.indexOf(perm.code) > -1 && perm.name != 'Super Admin Panel') {
                                            user.parsedPermissions.push(perm.name)
                                        }
                                    }
                                }
                                this.noUsers = !Boolean(this.usersList.length);
                                this.loading = false;
                            })
                    })
                    .catch(error => {
                        this.loading = false;
                        console.log(error);
                    })
            },
            editUser(user) {
                this.$session.set('editUserData', user)
                if (this.showDisabled) {
                    this.$session.set('showDisabled', true)
                }
                this.$router.push('/admin/users-permissions/edit-super-admin')
            },
            rejectChanges(){
                if (this.editUserData.firstName != this.initialUserData.firstName ||
                    this.editUserData.lastName != this.initialUserData.lastName ||
                    this.editUserData.role.roleId != this.initialUserData.role.roleId ||
                    this.newPassword != '' ||
                    this.editUserData.mailingLists.news != this.initialUserData.mailingLists.news ||
                    this.editUserData.mailingLists.invoice != this.initialUserData.mailingLists.invoice ||
                    this.editUserData.mailingLists.maintenance != this.initialUserData.mailingLists.maintenance
                ) {
                    this.$refs['unsaved'].show();
                } else {
                    //this.showAdminModal = false;
                    this.$refs['editUserModal'].hide();
                }
            },
            saveChanges(){
                if (this.blockEdition) {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Edition not allowed',
                        text: 'You are not allowed to edit following data.',
                        duration: 5000,
                    });
                } else if ((this.editUserData.email != this.initialUserData.email) && this.blockEmailEdition) {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Edition not allowed',
                        text: 'You are not allowed to edit this email address.',
                        duration: 5000,
                    });
                } else {
                    let parsedData = {};
                    if (this.editUserData.firstName != this.initialUserData.firstName) {
                        parsedData.firstName = this.editUserData.firstName;
                    }
                    if (this.editUserData.lastName != this.initialUserData.lastName) {
                        parsedData.lastName = this.editUserData.lastName;
                    }
                    if (this.editUserData.email != this.initialUserData.email) {
                        parsedData.email = this.editUserData.email;
                    }
                    if (this.editUserData.role.roleId != this.initialUserData.role.roleId) {
                        parsedData.roleId = this.editUserData.role.roleId;
                    }
                    if (this.newPassword != '') {
                        parsedData.password = this.newPassword;
                    }
                    if (this.editUserData.mailingLists.news != this.initialUserData.mailingLists.news ||
                    this.editUserData.mailingLists.invoice != this.initialUserData.mailingLists.invoice ||
                    this.editUserData.mailingLists.maintenance != this.initialUserData.mailingLists.maintenance) {
                        parsedData.mailingLists = {
                            news: this.editUserData.mailingLists.news,
                            invoice: this.editUserData.mailingLists.invoice,
                            maintenance: this.editUserData.mailingLists.maintenance
                        }
                    }

                    if(Object.keys(parsedData).length > 0 && parsedData.constructor === Object) {

                        if (parsedData.roleId == 4) {
                            this.$notify({
                                type: 'error',
                                group: 'notification',
                                title: 'User not updated',
                                text: 'You can not make this user the owner.',
                                duration: 5000,
                            });
                        } else {
                            Axios.patch(globalStorage.data.restApiUrl + '/admin/users/' + this.editUserData.userId, parsedData)
                                .then(response => {
                                    if (response.status == 200 || response.status == 204) {
                                        this.$notify({
                                            type: 'success',
                                            group: 'notification',
                                            title: 'User updated',
                                            text: 'Your changes has been saved.',
                                            duration: 5000,
                                        });
                                        //this.showAdminModal = false;
                                        this.$refs['editUserModal'].hide();
                                        this.$refs['unsaved'].hide();
                                        this.getUsers();
                                    }
                                })
                                .catch(error => {
                                    this.$notify({
                                        type: 'error',
                                        group: 'notification',
                                        title: 'User not updated',
                                        text: 'Something went wrong during saving changes. Please, contact support.',
                                        duration: 5000,
                                    });
                                    console.log(error);
                                })
                        }
                    } else {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'No changes introduced',
                            text: 'You did not introduces any changes to save.',
                            duration: 5000,
                        });
                    }
                }
            },
            cancelChanges() {
                //this.showAdminModal = false;

                this.$refs['editUserModal'].hide();
                this.$refs['unsaved'].hide();
            },
            disableUser() {
                if (this.blockEdition || this.blockEmailEdition) {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Disable not allowed',
                        text: 'You can not disable this user.',
                        duration: 5000,
                    });
                    this.$refs['disableUserModal'].hide();
                } else {
                    Axios.patch(globalStorage.data.restApiUrl + '/admin/accounts/' + this.editUserData.userId + '/disabled/true')
                    .then(response => {
                        if (response.status == 200 || response.status == 204) {
                            this.$notify({
                                type: 'success',
                                group: 'notification',
                                title: 'User disabled',
                                text: 'User account has been successfully disabled.',
                                duration: 5000,
                            });
                            this.getUsers();
                            //this.showAdminModal = false;
                            this.$refs['editUserModal'].hide();
                            this.$refs['disableUserModal'].hide();
                        }
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'User not disabled',
                            text: 'Something went wrong during disabling user account. Please, contact support.',
                            duration: 5000,
                        });
                        console.log(error);
                    })
                }
            },
            reactiveUser() {
                if (this.blockEdition || this.blockEmailEdition) {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Disable not allowed',
                        text: 'You can not disable this user.',
                        duration: 5000,
                    });
                    this.$refs['disableUserModal'].hide();
                } else {
                    Axios.patch(globalStorage.data.restApiUrl + '/admin/accounts/' + this.editUserData.userId + '/disabled/false')
                        .then(response => {
                            if (response.status == 200 || response.status == 204) {
                                this.$notify({
                                    type: 'success',
                                    group: 'notification',
                                    title: 'User reactivated',
                                    text: 'User account has been successfully reactivated.',
                                    duration: 5000,
                                });
                                this.getUsers();
                                //this.showAdminModal = false;
                                this.$refs['editUserModal'].hide();
                                this.$refs['disableUserModal'].hide();
                            }
                        })
                        .catch(error => {
                            this.$notify({
                                type: 'error',
                                group: 'notification',
                                title: 'User not reactivated',
                                text: 'Something went wrong during reactivated user account. Please, contact support.',
                                duration: 5000,
                            });
                            console.log(error);
                        })
                }
            },
            showDisableUserModal() {
                let email = this.$cookies.get('userEmail');
                let initialEmail = this.initialUserData.email;

                if (email != initialEmail) {
                    this.$refs['disableUserModal'].show();
                } else {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'User can not be disabled',
                        text: 'You can not disable user you are currently logged on.',
                        duration: 5000,
                    });
                }
            },
            getLoggedMail() {
                this.loggedUser.email = this.$session.get('userEmail');
                this.loggedUser.accessLevel = this.$session.get('userLevel');
            },
            newUserModalShow() {
                if (this.showDisabled) {
                    this.$session.set('showDisabled', true)
                }
                this.$router.push('/admin/users-permissions/create-super-admin')
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                if ((from.name != 'Create new user' && from.name != 'Edit Super Admin') && vm.$session.get('showDisabled')) {
                    vm.$session.remove('showDisabled')
                }
            })
        },
        mounted() {
            this.showDisabled = this.$session.get('showDisabled') ? this.$session.get('showDisabled') : false
            this.getUsers();
            this.getLoggedMail();
        }
    }
</script>

<style src="spinkit/scss/spinkit.scss" lang="scss" />
<style lang="scss">

    .user-premission {
        .card {
            .card-body {
                &.user-loading {
                    min-height: 400px;
                }
            }
        }
    }
    .loader-users-list {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;

        background-color: rgba(255, 255, 255, 0.7);

        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;

        .sk-wave {
            height: 60px;
            .sk-rect {
                width: 3px;
                background-color: #39c354;
                border-radius: 4px;
            }
        }

        .text {
            margin-top: 20px;
            text-align: center;
            font-size: 15px;
            font-weight: 700;
        }
    }
    .inner-client {
        .header-list-client {
            display: flex;
            justify-content: flex-start;
            padding: 0;
            margin-bottom: 20px;

            .header-item {
                font-weight: 700;
                font-size: 15px;

                &:nth-child(1) {
                    width: 30%;
                }

                &:nth-child(2) {
                    width: 20%;
                }

                &:nth-child(3) {
                    width: 50%;
                    display: flex;
                    justify-content: space-between;
                    .show-disabled {
                        display: flex;
                        align-items: center;
                        .show-disabled-label {
                            margin-left: 10px;
                            font-weight: 400;
                        }
                    }
                }
            }
        }

        .list-client {
            .item {
                position: relative;
                padding: 20px;
                margin-bottom: 20px;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                background-color: #F2F2F2;
                border: 1px solid #C9CFD4;
                border-radius: 5px;

                &.user-disabled {
                    opacity: 0.5;
                }

                .user {
                    width: 30%;
                .img-wrap {
                    margin-right: 20px;
                    .light-mode-img {
                        display: block;
                    }
                    .dark-mode-img {
                        display: none;
                    }
                }

                    display: flex;
                    justify-content: flex-start;
                    align-items: center;

                    .img-wrap {
                        margin-right: 20px;
                    }

                    .data-wrap {
                        display: flex;
                        flex-direction: column;

                        strong {
                            font-size: 15px;
                            font-weight: 700;
                            color: #2F353A;
                        }

                        span {
                            font-size: 10px;
                            font-weight: 400;
                            color: #2F353A;
                        }
                    }
                }

                .role {
                    width: 20%;

                    span {
                        padding: 4px 27px;
                        border-radius: 12px;

                        font-size: 12px;
                        line-height: 20px;
                        color: #fff;
                        background-color: #fff;

                        &.Administrator {
                            background-color: #FC4D4D;
                        }

                        &.Provisioning,
                        &.Fulfilment {
                            background-color: #4DB0FC;
                        }

                        &.Billing {
                            background-color: #747FE2;
                        }

                        &.Super.Admin {
                            background-color: #FC4DE5;
                        }

                        &.Owner {
                            background-color: #FC4D4D;
                        }

                        &.Support {
                            background-color: #7B4DFC;
                        }

                        &.Sales {
                            background-color: #00C4B0;
                        }
                    }
                }
                .premission {
                    width: 50%;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;

                    .item {
                        padding: 5px 33px;
                        margin: 0 10px 0 0;

                        background-color: #3A4149;
                        background-image: url("../../assets/img/check-roles.png");
                        background-repeat: no-repeat;
                        background-position: 5px center;
                        font-size: 14px;
                        line-height: 24px;
                        color: #fff;
                    }
                }

                .actions {
                    width: 50%;
                    display: flex;
                    justify-content: space-between;
                    .permissions-list {
                        display: flex;
                        flex-wrap: wrap;
                        .permission-item {
                            margin: 0 20px 14px 0;

                            &:before {
                                content: '';
                                display: inline-block;
                                height: 8px;
                                width: 8px;
                                border-radius: 50%;
                                display: inline-block;
                                background-color: #0088ff;
                                margin-right: 8px;
                            }
                        }
                    }
                    button {
                        background: transparent;
                        border: 0;
                        padding: 0;
                        outline: none;
                        i {
                            margin: 0;
                        }
                    }
                }
            }
        }
    }
    #admin-edit-user___BV_modal_outer_ {
        .modal-header {
            position: absolute;
            right: 0;
            top: 0;
            z-index: 2050;
        }
        .modal-body {
            padding: 0;
            /*.disable-edition {*/
            /*    position: absolute;*/
            /*    top: 0;*/
            /*    bottom: 0;*/
            /*    left: 0;*/
            /*    right: 0;*/
            /*    background-color: rgba(0, 0, 0, 0.2);*/
            /*    z-index: 2000;*/
            /*}*/
            .content-box {
                padding: 0;
                overflow: hidden;
                display: flex;
                justify-content: space-between;

                .sidebar {
                    width: 20%;
                    position: relative;
                    width: auto;
                    height: auto;
                    background-color: transparent;
                    color: #2F353A;

                    .header-section {
                        padding: 20px;
                        font-size: 15px;
                        line-height: 21px;
                        font-weight: 700;
                        background-color: #F0F3F5;
                    }

                    .sidebar-roles {
                        padding: 0 20px;

                        li {
                            display: block;

                            &:last-child {
                                margin-bottom: 0;
                            }
                            input[type="radio"] {
                                display: none;

                                &:checked + label::after {
                                    content: '';
                                    position: absolute;
                                    left: 4px;
                                    top: 8px;
                                    width: 8px;
                                    height: 8px;
                                    background-color: #2F353A;
                                    border-radius: 50%;
                                }
                            }

                            label {

                                position: relative;
                                cursor: pointer;
                                margin: 0;
                                padding-left: 35px;
                                &::before {
                                    content: '';
                                    display: block;
                                    position: absolute;
                                    left: 0;
                                    top: 4px;
                                    width: 16px;
                                    height: 16px;
                                    border: 2px solid #2F353A;
                                    border-radius: 50%;
                                }

                                input:checked + label::before {
                                    background-color: #000;
                                }
                                &::before {
                                    content: '';
                                    display: block;
                                    position: absolute;
                                    left: 0;
                                    top: 4px;
                                    width: 16px;
                                    height: 16px;
                                    background: #f2f2f2;
                                    border: 1px solid #000;
                                    border-radius: 50%;
                                }
                                strong {
                                    display: block;
                                    font-size: 14px;
                                    line-height: 24px;
                                    font-weight: 400;
                                }
                                em {
                                    display: block;
                                    font-size: 10px;
                                    line-height: 13px;
                                    font-style: normal;
                                    color: #515B65;
                                }
                            }

                            input[disabled="disabled"] + label {
                                &::before {
                                    border-color: #c9cfd4;
                                }

                                strong,
                                em {
                                    color: #c9cfd4;
                                }
                            }

                            input[disabled="disabled"]:checked + label {
                                &::after {
                                    background-color: #c9cfd4;
                                }
                            }
                        }
                    }

                    .sidebar-email {
                        padding: 0 20px;
                        list-style: none;

                        li {
                            display: block;

                            &:last-child {
                                margin-bottom: 0;
                            }
                        }
                    }
                }

                .header-modal-text {
                    padding: 20px;
                    font-size: 15px;
                    line-height: 21px;
                    font-weight: 700;
                    margin-bottom: 0;
                }

                .content-modal {
                    width: 80%;
                    fieldset {
                        padding: 5px 20px;
                        input[disabled="disabled"] {
                            color: #73818f;
                        }
                    }
                    &.fields-blocked {
                        fieldset {
                            label {
                                color: #c9cfd4;
                            }

                            input {
                                color: #c9cfd4;
                                &::placeholder {
                                    color: #c9cfd4;
                                }
                            }
                        }
                    }
                }
            }
        }
        .control-bar {
            display: flex;
            justify-content: space-between;
            align-items: center;
            background-color: #f0f3f5;
            padding: 20px;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            border-top: none;
            .disable-user {
                color: #FC4D4D;
                cursor: pointer;
                &.block-disable {
                    pointer-events: none;
                    color: #c9cfd4;
                }
            }
            .cancel-save-btns {
                .btn {
                    padding: 8px 20px;
                }
                .btn-success {
                    margin-left: 10px;
                }
            }
        }
    }



    #unsaved___BV_modal_content_ ,
    #disableUserModal___BV_modal_content_ {
        .modal-header {
            padding-bottom: 0;
        }

        .modal-body {
            padding: 0 1rem 1rem;
            text-align: center;

            i {
                color: #0088FF;
                margin-bottom: 15px;
            }

            img {
                height: 19px;
                width: auto;
                margin-bottom: 15px;
            }

            h3 {
                display: block;
                margin-bottom: 18px;
                font-size: 15px;
                line-height: 18px;
                font-weight: 700;
                color: #2F353A;
            }

            h4 {
                display: block;
                margin-bottom: 20px;
                font-size: 14px;
                line-height: 24px;
                color: #515B65;
            }

            .button-wrapper {
                button {
                    margin: 0 5px;
                    padding-left: 15px;
                    padding-right: 15px;
                }
            }
        }
    }

    #newUserModal___BV_modal_body_ {
        display: flex;
        padding: 0;
        .left-side {
            padding: 20px 0;
            border-right: 1px solid #c8ced3;
            .title-header {
                margin: 0 0 22px;
                padding: 0 20px;
                font-size: 14px;
                font-weight: 700;
            }

            p {
                margin: 8px 0 20px;
                padding: 0 20px 20px;
                font-size: 14px;
                border-bottom: 1px solid #F0F3F5;
            }

            .section-header {
                font-size: 15px;
                padding: 0 20px;
                font-weight: 400;
            }

            select.form-control {
                max-width: calc(100% - 40px);
                margin: 0 20px;
            }

            fieldset {
                padding: 0 20px;
            }
        }
        .right-side {
            padding: 20px 0;
            flex-grow: 1;

            .title-header {
                margin: 0 0 22px;
                padding: 0 20px;
                font-size: 14px;
                font-weight: 700;
            }

            .permissions-checkboxes {
                padding: 0 20px;
                .permission-item {
                    display: flex;
                    align-items: center;
                    .radio-box {
                        margin: 6px 0;

                        input[type="radio"] {
                            display: none;

                            &:checked + label::after {
                                content: '';
                                display: inline-block;
                                position: absolute;
                                left: 4px;
                                top: 4px;
                                width: 8px;
                                height: 8px;
                                margin-right: 8px;
                                background-color: #2F353A;
                                border-radius: 50%;
                            }
                        }

                        label {
                            position: relative;
                            display: flex;
                            margin: 0;

                            &::before {
                                content: '';
                                display: inline-block;
                                width: 16px;
                                height: 16px;
                                border: 2px solid #2F353A;
                                border-radius: 50%;
                                margin-right: 8px;
                            }
                        }
                    }
                    .radio-box,
                    .checkbox-box {
                        width: 200px;
                        margin-right: 50px;
                    }
                    .description {
                        color: #515B65;
                    }
                }
            }
            .control-bar {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 20px 20px 0;
                a {
                    color: #0088FF;
                    font-weight: 700;
                }
            }
        }
    }


    .dark-theme {
        .loader-users-list {
            background-color: rgba(0, 0, 0, 0.4);
        }

        .list-client {
            background-color: #3a4149;
            border-color: #1a1c1d;

            .item {
                background-color: #2f353a;
                border-color: #1a1c1d;

                .user {
                    .img-wrap {
                        .light-mode-img {
                            display: none;
                        }

                        .dark-mode-img {
                            display: block;
                        }
                    }

                    .data-wrap {
                        strong,
                        span {
                            color: #edeeef;
                        }
                    }
                }

                .actions {
                    .edit-user {
                        .fa-pencil {
                            color: #edeeef;
                        }
                    }
                }
            }
        }

        .modal-content {
            background-color: #3a4149;
            color: #edeeef;

            .modal-header {
                .close {
                    color: #edeeef;
                    opacity: 1;
                }
            }

            .modal-body {
                .sidebar {
                    .header-modal-text {
                        color: #edeeef;
                    }

                    .header-section {
                        color: #edeeef;
                        background-color: #2f353a !important;
                    }

                    .sidebar-roles {
                        li {

                            input[type="radio"] {

                                &:checked + label::after {
                                    background-color: #edeeef;
                                }
                            }

                            label {
                                color: #edeeef;

                                &::before {
                                    border: 2px solid #edeeef;
                                }

                                em {
                                    color: #edeeef;
                                }
                            }
                        }
                    }
                }

                .content-modal {
                    fieldset {
                        .form-control {
                            background-color: #515b65;
                            border-color: #1a1c1d;
                            color: #edeeef;
                            &::placeholder {
                                color: #9FA3A7;
                            }
                        }
                    }
                }
            }
        }
        #admin-edit-user___BV_modal_outer_ {
            .modal-content {
                .modal-body {
                    .content-box {
                        .sidebar {
                            .sidebar-roles {
                                li {
                                    input + label {
                                        &::before {
                                            border-color: #3A4149;
                                            background-color: #f2f2f2;
                                        }

                                        strong,
                                        em {
                                            color: #edeeef;
                                        }
                                    }

                                    input:checked + label {
                                        &::after {
                                            background-color: #3a4149;
                                        }
                                    }
                                }


                                li {
                                    input[disabled="disabled"] + label {
                                        &::before {
                                            border-color: #80868D;
                                            background-color: #3a4149;
                                        }

                                        strong,
                                        em {
                                            color: #80868D;
                                        }
                                    }

                                    input[disabled="disabled"]:checked + label {
                                        &::after {
                                            background-color: #80868D;
                                        }
                                    }
                                }
                            }
                        }
                        .content-modal {
                            fieldset {
                                input[disabled="disabled"] {
                                    color: #80868D;
                                }
                            }
                            &.fields-blocked {
                                fieldset {
                                    label {
                                        color: #80868D;
                                    }

                                    input {
                                        color: #80868D;
                                        &::placeholder {
                                            color: #80868D;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    .control-bar {
                        background-color: #2f353a;
                        .disable-user {
                            &.block-disable {
                                color: #9FA3A7;
                            }
                        }
                    }
                }
            }
        }



        #unsaved___BV_modal_content_ ,
        #disableUserModal___BV_modal_content_ {

            .modal-body {

                i {
                    color: #0088FF;
                }

                h3 {
                    color: #FFFFFF;
                }

                h4 {
                    color: #edeeef;
                }
            }
        }
    }

</style>
